export function isGoSpace(codePoint: number): boolean {
  if (codePoint <= 0xff) {
    return (
      (codePoint >= 0x09 && codePoint <= 0x0d) ||
      codePoint === 0x20 ||
      codePoint === 0x85 ||
      codePoint === 0xa0
    )
  }
  return (
    codePoint === 0x1680 ||
    (codePoint >= 0x2000 && codePoint <= 0x200a) ||
    codePoint === 0x2028 ||
    codePoint === 0x2029 ||
    codePoint === 0x202f ||
    codePoint === 0x205f ||
    codePoint === 0x3000
  )
}

export function trimGoSpace(value: string): string {
  let start = 0
  let end = value.length
  while (start < end && isGoSpace(value.charCodeAt(start))) {
    start += 1
  }
  while (end > start && isGoSpace(value.charCodeAt(end - 1))) {
    end -= 1
  }
  return value.slice(start, end)
}

export function countRunes(text: string): number {
  let count = 0
  for (let i = 0; i < text.length; i += 1) {
    const isHighSurrogate = text.charCodeAt(i) >= 0xd800 && text.charCodeAt(i) <= 0xdbff
    const nextUnit = text.charCodeAt(i + 1)
    if (isHighSurrogate && nextUnit >= 0xdc00 && nextUnit <= 0xdfff) {
      i += 1
    }
    count += 1
  }
  return count
}
